export default __webpack_public_path__ + "static/media/nug.75e2a695.jpeg";